export default __webpack_public_path__ + "static/media/news.a101a470.png";